import { cn } from "@/lib/utils";

export const PageSection = ({
  children,
  className,
  id
}: {
  children: React.ReactNode;
  className?: string;
  id?: string;
}) => {
  return (
    <section
      id={id}
      className={cn(
        "flex min-h-screen flex-col items-center py-24 px-8 md:py-32 md:px-12 max-w-4xl mx-auto",
        className
      )}>
      {children}
    </section>
  );
};
